// extracted by mini-css-extract-plugin
export default {"footerWrapper":"Footer_footerWrapper__iSQnh","text":"Footer_text__Ie4sD"};